import React from "react";

const PrivacyPolicy = () => {
    return (
        <div className="legals-box">
            <div className="w-full max-w-3xl text-left">
                <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
            <p className="mb-6">Effective Date: 15/07/2025</p>

            <section className="mb-6">
                <p>
                    This Privacy Policy explains how ScrubMail ("we", "our", or
                    "us") collects, uses, and protects your personal information when you
                    use our email scrubbing service and website (the "Service").
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">1. Information We Collect</h2>
                <ul className="list-disc list-inside">
                    <li>
                        <strong>Account Information:</strong> When you register, we collect
                        your name, email address, and login credentials (including Google
                        login info, if used).
                    </li>
                    <li>
                        <strong>Payment Information:</strong> Payments are processed through
                        Stripe. We do not store payment card details on our servers.
                    </li>
                    <li>
                        <strong>Uploaded Data:</strong> We collect the email lists you
                        upload to provide the scrubbing service.
                    </li>
                    <li>
                        <strong>Analytics Data:</strong> We use Google Tag Manager and
                        cookies to track usage and improve our service.
                    </li>
                </ul>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">2. How We Use Your Information</h2>
                <ul className="list-disc list-inside">
                    <li>To provide and maintain the Service;</li>
                    <li>To process transactions and send related information;</li>
                    <li>To improve and personalize your experience;</li>
                    <li>To comply with legal obligations.</li>
                </ul>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">3. Data Storage and Transfers</h2>
                <p>
                    All user data is stored on secure servers located in the European Union.
                    We do not transfer your data outside the EU.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">4. Cookies and Tracking</h2>
                <p>
                    We use cookies and Google Tag Manager for analytics and to improve
                    your experience. By using our site, you agree to our use of cookies as
                    described in our <a href="/cookie-policy" className="text-blue-600 underline">Cookie Policy</a>.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">5. Sharing of Information</h2>
                <p>
                    We do not sell or rent your personal data. We only share your
                    information with:
                </p>
                <ul className="list-disc list-inside">
                    <li>Service providers (e.g., Stripe, Google);</li>
                    <li>Law enforcement if required by law;</li>
                    <li>
                        In connection with a business transfer (e.g., merger or acquisition).
                    </li>
                </ul>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">6. Your Rights</h2>
                <p>
                    Under the GDPR, you have the right to:
                </p>
                <ul className="list-disc list-inside">
                    <li>Access, correct, or delete your personal information;</li>
                    <li>Object to or restrict processing of your data;</li>
                    <li>Withdraw consent at any time;</li>
                    <li>Lodge a complaint with a data protection authority.</li>
                </ul>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">7. Data Retention</h2>
                <p>
                    We retain your data only as long as necessary to provide the Service
                    and comply with legal obligations. Uploaded email lists are deleted
                    after processing unless you choose to retain them.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">8. Security</h2>
                <p>
                    We take reasonable technical and organizational measures to protect your
                    information from unauthorized access, loss, or misuse.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-2xl font-semibold mb-2">9. Changes to This Policy</h2>
                <p>
                    We may update this Privacy Policy from time to time. Any changes will be
                    posted on this page with an updated effective date. Continued use of
                    the Service constitutes acceptance of the updated policy.
                </p>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">10. Contact Us</h2>
                <p>
                    If you have questions or concerns about this Privacy Policy, contact us at:
                </p>
                <ul className="mt-2">
                    <li>📧 Email: support@scrubmail.com</li>
                    <li>🏢 Address: Ja Som Bratislava 123, 85101 Bratislava, Slovakia</li>
                </ul>
            </section>
            </div>
        </div>
    );
};


export default PrivacyPolicy;